import { createFileRoute } from "@tanstack/react-router";

import { QcIssuesPage } from "../../../workspaces/library/pages/QcIssuesPage";

export const Route = createFileRoute("/_console/p/$org/$project/library/issues")({
  component: QcIssuesPage,
});
